import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_AWO_WITH_FLYERS } from '../../queries';
import SettingsPanel from './SettingsPanel';

function SettingsContent() {
  const { data, loading } = useQuery(GET_AWO_WITH_FLYERS);
  const awo = data?.awo;

  if (loading || !awo) return null;

  return <SettingsPanel awo={awo} />;
}

export default SettingsContent;
